export enum AuthGroup {
  FACILITATORS = 'Facilitators',
  OPERATORS = 'Operators',
  FINANCIERS = 'Financiers',
  VENDORS = 'Vendors',
  VENDOR_MANAGEMENT = 'VendorManagement',
  PARTNERS = 'Partners',
}

export function parseGroups(idTokenPayload: Record<string, unknown>): string[] {
  const raw = idTokenPayload['cognito:groups'];
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw.filter((item): item is string => typeof item === 'string');
}
